export const FilterSearchBar = (props) => {
    return <div className={`col-sm-${props.filter.gridWidth != 0 ? props.filter.gridWidth : 12}`}>
        {props.filter.title &&
            <label>
                <strong>{props.filter.title}</strong>
            </label>}
        <input type={"search"} className={"searchBar"}
            placeholder={props.filter.placeHolder}
            onChange={(evt) => props.setSearchTermHandler(evt.target.value)} />
    </div>;
}